module.exports = __webpack_public_path__ + "img/hotstyleshow6.908dc7de.jpg";